import {MouseEventHandler} from 'react'

interface ButtonProps {
  type: 'button' | 'submit' | 'reset'
  bg: 'success' | 'primary'
  style?: 'outline' | 'block'
  classes?: string[]
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined
  children: JSX.Element | string
  isLoading?: boolean,
  id?: string
}
export default function Button({
  type,
  bg,
  style = 'block',
  onClick,
  classes,
  children,
  isLoading = false,
  id
}: ButtonProps) {
  if (style === 'block') {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={isLoading}
        id={id}
        className={`${
          bg === 'success'
            ? 'bg-success text-primary focus:ring-success-100'
            : 'bg-primary text-white focus:ring-primary-100'
        }  focus:ring-2 sm:px-8 py-2 rounded-md flex justify-center items-center disabled:opacity-75  disabled:cursor-not-allowed ${classes?.join(
          ' ',
        )}`}>
        {children}

        {isLoading && (
          <svg
            className="animate-spin ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )}
      </button>
    )
  } else {
    return (
      <button
        type={type}
        onClick={onClick}
        className={`${
          bg === 'success'
            ? 'text-success border-2 border-success'
            : 'text-primary border-2 border-primary'
        }  rounded-md ${classes?.join(' ')}`}>
        {children}
      </button>
    )
  }
}
